import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { App } from './App';
import { appInsights } from './appInsights';
import { msalConfig } from './stateManagement/auth/authConfig';
import { CustomThemeProvider } from './theme/CustomThemeProvider';

const msalInstance = new PublicClientApplication(msalConfig);

// Track page load
appInsights.trackPageView({
  name: 'PageView',
  uri: window.location.href,
  properties: {
    language: navigator.language,
    referrer: document.referrer,
  },
});

// Ensure MSAL is initialized before using it
msalInstance
  .initialize()
  .then(() => {
    msalInstance.enableAccountStorageEvents(); // 👈 enables cross-tab login sync

    // CRITICAL: Handle redirect promise to process authentication responses
    msalInstance
      .handleRedirectPromise()
      .then(response => {
        if (response) {
          // Authentication successful, response contains account info
          // eslint-disable-next-line no-console
          console.log('Redirect response processed:', response);
        }

        const root = ReactDOM.createRoot(document.getElementById('root')!);
        root.render(
          <React.StrictMode>
            <CustomThemeProvider>
              <MsalProvider instance={msalInstance}>
                <App />
              </MsalProvider>
            </CustomThemeProvider>
          </React.StrictMode>,
        );
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Error handling redirect promise:', error);
        // Still render app even if redirect handling fails
        const root = ReactDOM.createRoot(document.getElementById('root')!);
        root.render(
          <React.StrictMode>
            <CustomThemeProvider>
              <MsalProvider instance={msalInstance}>
                <App />
              </MsalProvider>
            </CustomThemeProvider>
          </React.StrictMode>,
        );
      });
  })
  .catch(error => {
    // eslint-disable-next-line no-console
    console.error('Error initializing MSAL:', error);
    // Still render app even if initialization fails
    const root = ReactDOM.createRoot(document.getElementById('root')!);
    root.render(
      <React.StrictMode>
        <CustomThemeProvider>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </CustomThemeProvider>
      </React.StrictMode>,
    );
  });
